<script setup lang="ts">
import VueQueryWrapper from '@/components/VueQueryWrapper.vue'
import { useGetJobApplication } from '@swipe4work/api-orval'

definePage({
  name: '/job-applications.[jobApplicationId]',
  meta: {
    permissionResource: 'JobApplication',
  },
})

const route = useRoute('/job-applications.[jobApplicationId]')

const jobApplicationId = Number.parseInt(route.params.jobApplicationId)

const { data, error, isPending } = useGetJobApplication(jobApplicationId)
</script>

<template>
  <VueQueryWrapper :is-pending="isPending" :error="error">
    <template #isPending>
      <Skeleton height="20rem" />
    </template>
    <JobApplicationDetail v-if="data" :job-application="data" :source="(route.query.source as 'jobApplications' | 'jobDetail') ?? 'jobApplications'" />
  </VueQueryWrapper>
</template>
